export default "__VITE_ASSET__80882fe7__"